export default {
  today: 'Heute',
  tomorrow: 'Morgen',
};
